import { CatSkeleton } from '@blocks-react/components/Skeleton';
import expanderStyles from '../../../common/expander/styles.module.scss';
import { v4 as uuid } from 'uuid';

interface DealerLocatorSearchResultLoaderProps {
  numSkeletonLoaders: number;
}

export const DealerLocatorSearchResultLoader = ({
  numSkeletonLoaders
}: DealerLocatorSearchResultLoaderProps) => (
  <>
    {Array(numSkeletonLoaders)
      .fill(true)
      .map((_skeletonCard, index) => {
        return (
          <div
            className={expanderStyles['expander-loader']}
            key={`skeletonCard-${uuid()}`}
            data-testid="skeleton-loader"
          >
            <div className="cat-u-margin-top-lg px-1">
              <CatSkeleton
                width="40%"
                size="sm"
                className="cat-u-display-block cat-u-margin-bottom-md"
              />
              <CatSkeleton
                className="cat-u-display-block cat-u-margin-bottom-md"
                size="sm"
              />
              <CatSkeleton
                className="cat-u-display-block cat-u-margin-bottom-lg"
                size="sm"
              />
            </div>
          </div>
        );
      })}
  </>
);
